/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import { PlayIcon } from 'components/atoms/Icons/iconList';
import { FallbackImage } from '@rcw/ui';
import './videoCard.scss';

function VideoCard({
  element, isActive, className, body, onPlayChange, stopSignal, playOverlay, imageClassName,
}) {
  const [play, setPlay] = useState(false);
  const playerRef = useRef(null);

  const getVideoId = (url) => {
    try {
      const urlObj = new URL(url);
      return urlObj.searchParams.get('v') || urlObj.pathname.split('/').pop();
    } catch {
      return url;
    }
  };
  const videoId = getVideoId(element.videoUrl);
  const plainTitle = DOMPurify.sanitize(element.title, { ALLOWED_TAGS: [] });

  useEffect(() => {
    if (!isActive && play) {
      setPlay(false);
      onPlayChange?.(false);
    }
  }, [isActive]);

  useEffect(() => {
    if (stopSignal > 0) {
      setPlay(false);
      onPlayChange?.(false);
    }
  }, [stopSignal]);

  useEffect(() => {
    onPlayChange?.(play);
  }, [play]);

  useEffect(() => {
    if (play && window.YT && window.YT.Player) {
      playerRef.current = new window.YT.Player(`yt-player-${videoId}`, {
        events: {
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              setPlay(false);
              onPlayChange?.(false);
            }
          },
        },
      });
    }
    return () => {
      if (playerRef.current?.destroy) {
        playerRef.current.destroy();
      }
    };
  }, [play, videoId]);

  return (
    <div className={className}>
      <div
        className={`videoWrapper ${play ? '' : 'cursor-pointer'}`}
        role={play ? undefined : 'button'}
        tabIndex={play ? undefined : 0}
        aria-label={play ? undefined : `Play video: ${plainTitle}`}
        onClick={play ? undefined : () => setPlay(true)}
        onKeyDown={play ? undefined : (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setPlay(true);
          }
        }}
      >
        {play ? (
          <iframe
            id={`yt-player-${videoId}`}
            src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1`}
            title={plainTitle}
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
          />
        ) : (
          <>
            <FallbackImage
              src={element.thumbnailUrl ?? `https://img.youtube.com/vi/${videoId}/0.jpg`}
              alt={plainTitle}
              imgClassName={imageClassName}
              fetchPriority='high'
            />
            {playOverlay || (
            <div className='playIcon'>
              <PlayIcon />
            </div>
            )}
          </>
        )}
      </div>
      {body}
    </div>
  );
}

export default VideoCard;
